import * as GLOBAL_LABELS from "../labels/global";

export const LABELS = {
    [GLOBAL_LABELS.GLOBAL_DELETE]: "削除",
    [GLOBAL_LABELS.GLOBAL_CANCEL]: "キャンセル",
    [GLOBAL_LABELS.GLOBAL_UNKNOWN]: "不明",

    [GLOBAL_LABELS.GLOBAL_TEST_ENVIRONMENT_BANNER_TEST_MODE]: "Тестовый режим",
    [GLOBAL_LABELS.GLOBAL_TEST_ENVIRONMENT_BANNER_LIVE_TEST_MODE]: "Режим производственных испытаний",
    [GLOBAL_LABELS.GLOBAL_ENVIRONMENT_MODE_CONFIRMATION_MODAL_MESSAGE]: "Эта оплата находится в режиме {mode}. Фактическая оплата не будет произведена.",
    [GLOBAL_LABELS.GLOBAL_ENVIRONMENT_MODE_CONFIRMATION_MODAL_BUTTON]: "Я понимаю",
};

export default LABELS;
